// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2494919b","239":"0a2daa60","453":"67c11f13","732":"22e00380"}[chunkId] + ".chunk.js";
};